import useAwsMarketPlaceQueryParamsMessage from '../../hooks/useAwsMarketPlaceQueryParamsMessage';

const ResolvedLogin = () => {
  useAwsMarketPlaceQueryParamsMessage();

  return <div />;
};

export default ResolvedLogin;
